export const formatUicClass = (uicClass: string): string => uicClass.slice(0, 2)
